import './App.css';
import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from './layout/Layout';
import Beacons from './pages/beacons/Beacons';
import BeaconsStores from './pages/beaconStore/BeaconsStores';
import BeaconsTypes from './pages/beaconTypes/BeaconsTypes';
import Customers from './pages/customers/Customers';
import Permissions from './pages/permissions/Permissions';
import Products from './pages/products/Products';
import Technicians from './pages/technicians/Technicians';
import Users from './pages/users/Users';
import Assets from './pages/assets/Assets';
import RolesFn from './pages/roles/Roles';
import Login from './login/Login';
import Missing from './utils/Missing';
import RequireAuth from './components/requireAuth/RequreAuth';
import PersistLogin from './login/PersistLogin';
import BillingsFn from './pages/billings/BillingsFn';
import DashBoard from './pages/dashboard/DashBoard';
import Unauthorized from './utils/Unauthorized';
import ForgotPasswordFn from './utils/ForgotPassword';
import ResetPassword from './utils/ResetPassword';

function App() {

    const PERMISSIONS = {
        'Assets': ["asset-create", "asset-delete", "asset-edit", "asset-list"],
        'billings': ["billings-list", "billings-create", "billings-edit", "billings-delete"],
        'beacons': ["beacon-list", "beacon-create", "beacon-edit", "beacon-delete"],
        'beaconStore': ["beacon-store-list", "beacon-store-create", " beacon-store-edit", "beacon-store-delete"],
        'beaconType': ["beacon-types-list", "beacon-types-create", "beacon-types-edit", "beacon-types-delete"],
        'customers': ["customer-list", "customer-create", "customer-edit", "customer-delete"],
        'products': ["product-list", "product-create", "product-edit", "product-delete"],
        'technicians': ["technician-list", "technician-create", "technician-edit", "technician-delete"],
        'users': ["user-list", "user-create", "user-edit", "user-delete"],
        'permission': ["permission-list", "permission-create", "permission-edit", "permission-delete"],
        'roles': ["role-list", " role-create ", "role-edit", "role-delete"],
    }

    return (
        <>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="unauthorized" element={<Unauthorized />} />
                <Route path="forgotPassword" element={<ForgotPasswordFn />} />
                <Route path="resetPassword/:token" element={<ResetPassword />} />
                <Route element={<PersistLogin />}>
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.Assets} />}>
                            <Route path="assets" element={<Assets />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.billings} />}>
                            <Route path="billings" element={<BillingsFn />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.beacons} />}>
                            <Route path="beacons" element={<Beacons />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.beaconStore} />}>
                            <Route path="beaconsStores" element={<BeaconsStores />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.beaconType} />}>
                            <Route path="beaconsTypes" element={<BeaconsTypes />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.customers} />}>
                            <Route path="customers" element={<Customers />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.permission} />}>
                            <Route path="permissions" element={<Permissions />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.roles} />}>
                            <Route path="roles" element={<RolesFn />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.products} />}>
                            <Route path="products" element={<Products />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.technicians} />}>
                            <Route path="technicians" element={<Technicians />} />
                        </Route>
                        <Route element={<RequireAuth allowedPermissions={PERMISSIONS.users} />}>
                            <Route path="users" element={<Users />} />
                        </Route>
                        <Route path="dashboard" element={<DashBoard />} />
                    </Route>
                </Route>
                <Route path="*" element={<Missing />} />
            </Routes>
        </>
    );
}

export default App
